import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

/**
 * Founder-mandated centralized disclaimer for DIRECT (automated, un-reviewed)
 * quantitative results under the approved Split Model.
 */
export function DirectResultsDisclaimer({ className = '' }) {
  const { i18n } = useTranslation();
  const isES = (i18n.language || 'es').startsWith('es');
  return (
    <div
      className={`rounded-md border border-amber-200 bg-amber-50 p-3 flex gap-2.5 ${className}`}
      data-testid="direct-results-disclaimer"
    >
      <AlertTriangle className="h-4 w-4 text-amber-700 mt-0.5 shrink-0" />
      <div className="text-xs text-amber-900 leading-relaxed">
        <p className="font-bold uppercase tracking-wide mb-1">
          {isES ? 'Aviso importante' : 'Important notice'}
        </p>
        <p>
          {isES
            ? 'Los resultados presentados corresponden al procesamiento automatizado del instrumento aplicado y deben ser interpretados por una persona idónea y dentro del contexto correspondiente. No constituyen por sí solos un diagnóstico, análisis o evaluación psicológica, médica, psiquiátrica ni clínica, ni deben utilizarse como único criterio para adoptar decisiones sobre una persona. Cuando se requiera una interpretación profesional de los resultados, solicite la revisión correspondiente por personal calificado.'
            : 'The results shown correspond to the automated processing of the applied instrument and must be interpreted by a qualified person within the appropriate context. On their own they do not constitute a psychological, medical, psychiatric or clinical diagnosis, analysis or evaluation, and must not be used as the sole criterion for decisions about a person. When a professional interpretation of the results is required, request the corresponding review by qualified personnel.'}
        </p>
      </div>
    </div>
  );
}

export default DirectResultsDisclaimer;
